import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../redux/actions'
import StreetGallery from '../component/streetGallery'
import _ from 'lodash';
import { Link } from 'react-router-dom';
import "./style.less"
import {Heart} from 'src-features/commonUI/arrow';
import {localStore} from 'src-common/utils';
import LoaderCover from 'src-features/commonUI/loadingCover';
import Gallery from 'src-commonUI/photoGallery';
import InfiniteScroll from 'src-commonUI/infiniteLoad';
import Loader from 'src-commonUI/infiniteLoad/loader'
import LazyLoad from 'src-commonUI/lazyload';
// <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" style="height: 331px; width: 248px;">
class Feed extends Component {
    constructor(props) {
        super(props);
    }
    fetchFeeds = (page) => {
        if(this.props.isFetchingFeed) return;
        this.props.fetchFeeds({
            page: page,
            page_size: 10,
        }).then(() => {
            this.setState({
                page: page,
                isFirstLoad: false
            })
        });
    }
    // componentDidMount() {
    //     this.fetchFeeds(this.state.page);
    // }
    
    render() {
        const {feeds, isFetchingFeed} = this.props;

        return (
            <div className="home-content-container">
                <section className="slogan">
                    <p>Imagine yourself in</p>
                    <h1>10 million looks</h1>
                </section>
                <InfiniteScroll
                    pageStart={0}
                    loadMore={this.fetchFeeds}
                    hasMore={!this.props.isFeedsEnd && !isFetchingFeed}
                    threshold={800}
                >
                    {!_.isEmpty(feeds) && <Gallery 
                        photos={feeds.filter(feed => !_.isEmpty(feed)).map(feed => ({
                            key:feed.street_for_analysis_id,
                            src: feed.street_image_url,
                            width: feed.street_image_width,
                            height: feed.street_image_height,
                            s_id: feed.street_for_analysis_id,
                            i_id: feed.influencer_id,
                            display_name: feed.influencer_name
                        }))} 
                        direction={"column"}
                        ImageComponent={ImageComponent}
                    />
                    }
                    {!this.props.isFeedsEnd && <Loader />}
                </InfiniteScroll>
                
                {/* <StreetGallery hasMore={!this.props.isFeedsEnd} list={feeds} loadFunc={this.fetchFeeds} isFetching={isFetchingFeed} cellContent={cellContent}/> */}
            </div>
        )
    }
}

const ImageComponent = ({ index, onClick, photo, margin, direction, top, left }) => {
    const bgColors = ['#3392E0', '#31A503', '#FFE500','#FF7700','#ED1409'];
    const imgStyle = { margin: margin, backgroundColor:bgColors[Math.floor(Math.random() * bgColors.length)] };
    if (direction === 'column') {
        imgStyle.position = 'absolute';
        imgStyle.left = left;
        imgStyle.top = top;
    }

    const handleClick = event => {
        onClick(event, { photo, index });
    };
    

    return (
        <div className="gallery-cell-container" style={onClick ? { ...imgStyle, ...{ cursor: 'pointer' }} : imgStyle}>
            <div className="street-caption">
                <span className="influencer-avatar">
                <Link 
                    style={{
                        textDecoration: 'none',
                        color: '#FFF',
                        display: 'block'
                    }} 
                    to={`/influencer/${photo['i_id']}`}
                >{photo.display_name}</Link></span>
            </div>
            <Link 
                to={`/streetsnap/${photo['s_id']}`}
                style={{
                    textDecoration: 'none',
                    color: '#FFF',
                }} 
            >
            <LazyLoad 
                // placeholder = {<div style={{ height: photo.height, width: photo.width, backgroundColor:bgColors[Math.floor(Math.random() * bgColors.length)]}}/>}
                placeholder={<img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" style={{ height: photo.height, width: photo.width}} />}
                throttle
                offset={400}
                unmountIfInvisible
            >
                <img
                    width={photo.width}
                    height={photo.height}
                    src={photo.src}
                    style={{display: 'block'}}
                    // onClick={onClick ? handleClick : null}
                />
            </LazyLoad>
            </Link>
        </div>
    );
}
const favorite = (id) => () => {
    let oldData = localStore.getStore('interact_data');
    oldData.interact_data.street_id_list.push(id);
    localStore.setStore('interact_data', oldData);
}
function cellContent(columnWidth, datum) {
    return (
        
        <div className="cell-container">

            <div
                style={{
                    backgroundColor: '#aaaaaa',
                    //   height: datum.size * 3,
                    width: '100%',
                    height: columnWidth*(datum.street_image_height / datum.street_image_width),
                    fontSize: 20,
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden'
                }}>
                <img style={{maxWidth: '100%'}} src={datum.street_image_url}/>
            </div>
            <Link to={`/streetsnap/${datum['street_for_analysis_id']}`}>
            <div className="cell-cover">
            </div>
            </Link>
            <div className="cell-hidden">
                <Link 
                    style={{
                        textDecoration: 'none',
                        fontSize: '12px',
                        color: '#FFFFFF',
                        letterSpacing: '-0.21px',
                        paddingLeft: '10px'
                    }} 
                    to={`/influencer/${datum['influencer_id']}`}
                >{datum.influencer_name}</Link>
                <span style={{paddingRight: '10px'}}><Heart action={favorite(datum.street_for_analysis_id)}/></span>
            </div>
            
        </div>
    )
}

function mapStateToProps(state) {
    const {homepage} = state;

    return {
        feeds: homepage.feedsList,
        isFeedsEnd: homepage.isFeedsEnd,
        isFetchingFeed: !!homepage.isFetchingFeed
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({...actions}, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Feed)


// WEBPACK FOOTER //
// ./src/features/homepage/feed/container/feed.js